// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Bookmark_Filled_Corner0_Rounded = createSinglePathSVG({
  path: 'M17.25 3H6.75a1.5 1.5 0 0 0-1.5 1.5V21a.75.75 0 0 0 1.148.636L12 18.134l5.603 3.502A.75.75 0 0 0 18.75 21V4.5a1.5 1.5 0 0 0-1.5-1.5Z',
  viewBox: '0 0 24 24',
  glyph: 'Bookmark_Filled_Corner0_Rounded',
})

export const Bookmark_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M17.25 3H6.75a1.5 1.5 0 0 0-1.5 1.5V21a.75.75 0 0 0 1.148.636L12 18.134l5.603 3.502A.75.75 0 0 0 18.75 21V4.5a1.5 1.5 0 0 0-1.5-1.5Zm0 16.647-4.853-3.033a.75.75 0 0 0-.795 0L6.75 19.647V4.5h10.5Z',
  viewBox: '0 0 24 24',
  glyph: 'Bookmark_Stroke2_Corner0_Rounded',
})

export const BookmarkDelete_Stroke2_Corner0_Rounded_Large = createSinglePathSVG(
  {
    path: 'M46 8H18a4 4 0 0 0-4 4v44a2 2 0 0 0 3.06 1.695L32 48.358l14.943 9.337A2 2 0 0 0 50 56V12a4 4 0 0 0-4-4Zm0 44.393-12.942-8.088a2 2 0 0 0-2.12 0L18 52.392V12h28Z',
    viewBox: '0 0 64 64',
    glyph: 'BookmarkDelete_Stroke2_Corner0_Rounded_Large',
  },
)
